import SectionSeparator from "components/MdxSectionSeparator/sectionSeparator.jsx";
import vasivasireddy from "assets/img/blogs/aws-distro-for-opentelemetry-lambda-layer-v0.17.0/vasivasireddy.png";
import * as React from 'react';
export default {
  SectionSeparator,
  vasivasireddy,
  React
};